declare namespace $ {

	type $shm_hitalama_grid_table__sub_shm_hitalama_grid_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_grid['rows'] >
		,
		ReturnType< $shm_hitalama_grid_table['sub'] >
	>
	export class $shm_hitalama_grid extends $mol_grid {
		Table_view( ): $shm_hitalama_grid_table
		sub( ): readonly(any)[]
	}
	
	export class $shm_hitalama_grid_table extends $mol_view {
	}
	
}

//# sourceMappingURL=grid.view.tree.d.ts.map